<template>
  <router-view/>
</template>

<script>
export default {
  name: 'node.Bee'
}
</script>

<style>
@import './assets/css/home.main.css';
@import './assets/css/reset.min.css';
@import './assets/css/admin.css';
/* @import './assets/css/main.min.css'; */
</style>
